import { IComponentConfiguration } from '../models/IComponentConfiguration.js';

export const DEFAULT_COMPONENT_CONFIGURATION: IComponentConfiguration = {
	charting: {},
};
